import React from 'react'
import "./OverlayHero.css"
import Header from '../Header/Header'
import { useNavigate } from 'react-router-dom'

function OverlayHero({
    heading="",
    content="",
    btn=false,
    bgImg="/images/creative/new-home-hero-bg.webp"
}) {
    const navigate = useNavigate()
  return (
    <div className='OverlayHero-container'>
         <div style={{position:"relative",zIndex:"100"}}>
            <Header />
        </div>

         <div className='main-hero d-flex '
            style={{backgroundImage:`url(${bgImg})`}}
         >
            <div className='container-fluid'>
                <div className='row h-100' >
                    <div className='col-lg-6 content-main py-3'>
                        <div className='ps-lg-5 ms-lg-4 ps-1 pe-lg-0 pe-1 h-100'>
                            <div className='content-section d-flex flex-column h-100 justify-content-center text-center text-lg-start'>
                                <h1 className="hero-section-heading color-white" >
                                {heading}
                                </h1>
                                {/* <p className="body-paragraph color-white">Gain financial confidence with our expert tax and accounting services. Whether you are managing a small business or starting a new company, we guarantee that your finances will be optimized to work in your favor.</p> */}
                                <p className="body-paragraph color-white">{content}</p>
                                {btn && <button className="hero-btn blue-btn mx-auto mx-lg-0"  onClick={()=>{window.open("tel:+14169042013")}}>Get Consultation</button>}
                    
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-1 d-lg-block d-none second-slab'>

                    </div>
                    <div className='col-lg-1 d-lg-block d-none col-0 third-slab'>

                    </div>
                    <div className='col-lg-4 d-lg-block d-none col-0'>

                    </div>
                </div>
            </div>
         </div>
    </div>
  )
}

export default OverlayHero